/* jshint esversion: 6 */
// import 'external';

import $ from 'jquery';
// import throttle from 'lodash/throttle';

export default class StickyMenu {
    
    /**
     * [consoleLog description]
     *
     * @param {String} log [description]
     *
     * @return {[type]} [description]
     */
    consoleLog(log = '') {
        if (this.debug) {
            console.log('StickyMenu: ' + log);
        }
    }
    
    /**
     * [constructor description]
     *
     * @param {[type]} options [description]
     *
     * @return {[type]} [description]
     */
    constructor(options) {
        
        this.debug = false;
        
        this.defaults = {
            el: 'div.menu#_desktop_top_menu',
            levels: {
                '0': {
                    'list': 'ul.top-menu[data-depth="0"]',
                    'items': ' > li',
                    'submenus': ' > div',
                },
                '1': {
                    'list': 'ul.top-menu[data-depth="1"]',
                    'items': ' > li',
                    'submenus': ' > div',
                },
                '2': {
                    'list': 'ul.top-menu[data-depth="2"]',
                    'items': ' > li',
                    'submenus': ' > div',
                },
                '3': {
                    'list': 'ul.top-menu[data-depth="3"]',
                    'items': ' > li',
                    'submenus': ' > div',
                }
            }
        };
        
        // merge options with defaults
        this.options = $.extend({}, this.defaults, options);
        
        // merge this.option to this
        $.extend(this, this.options);
    }
    
    /**
     * [init description]
     *
     * @return {[type]} [description]
     */
    init() {
        if (this.check()) {
            this.prepare();
            this.run();
        }
    }
    
    /**
     * [check description]
     *
     * @return {[type]} [description]
     */
    check() {
        return $(this.el).length;
    }
    
    /**
     * [destroy description]
     *
     * @return {[type]} [description]
     */
    cleanup() {
        
    }
    
    /**
     * [prepare description]
     *
     * @return {[type]} [description]
     */
    prepare() {
        this.consoleLog('prepare [jquery: ' + $().jquery + ']');
        
        this.$window = $(window);
        this.$document = $(document);
        
        this.$el = $(this.el);
    }
    
    /**
     * [run description]
     *
     * @return {[type]} [description]
     */
    run() {
        this.consoleLog('run [jquery: ' + $().jquery + ']');
        this.execute();
    }
    
    /**
     * [onWindowResize description]
     *
     * @return {[type]} [description]
     */
    onWindowResize() {
        if (!this.check()) {
            return;
        }
        // this.submenuCss();
        document.location.reload(true);
    }
    
    /**
     * [execute description]
     *
     * @return {[type]} [description]
     */
    execute() {
        this.hideSubMenus();
        this.submenuCss();
        this.bindings();
    }
    
    /**
     * [submenuCss description]
     *
     * @return {[type]} [description]
     */
    submenuCss() {
        $(this.el + ' ' + this.levels[0].list + ' ' + this.levels[0].items + ' ' + this.levels[0].submenus).css({
            'max-height': ($(window).height() - 300) + 'px',
        });
    }
    
    /**
     * [hideSubMenus description]
     *
     * @return {[type]} [description]
     */
    hideSubMenus() {
        
        Object.keys(this.levels).forEach((key) => {
            if (key === '0') {
                return;
            }
            let level = this.levels[key];
            $(this.el + ' ' + level.list + ' ' + level.items + ' ' + level.submenus).hide();
        });
        // for (let [key, level] of Object.entries(this.levels)) {
        //     if (key === '0') {
        //         continue;
        //     }
        //     $(level.list + level.items + level.submenus).hide();
        // }
    }
    
    /**
     * [bindings description]
     *
     * @return {[type]} [description]
     */
    bindings() {
        
        Object.keys(this.levels).forEach((key) => {
            if (key === '0') {
                return;
            }
            
            let level = this.levels[key];
            
            $(this.el + ' ' + level.list + ' ' + level.items).each((index, Element) => {
                
                // check if has submenu
                if ($(Element).find(level.submenus).length) {
                    
                    // if has submenu add open icon
                    $(Element).find('> a').before('<i class="fas fa-chevron-right"></i>');
                    
                    // bind clicks to open submenus
                    $(Element).on('click', ' > i', (event) => {
                        event.preventDefault();
                        if ($(Element).find(level.submenus).is(":visible") == true) {
                            $(Element).find(level.submenus).hide();
                            $(Element).find(' > i').removeClass('fa-chevron-down').addClass('fa-chevron-right');
                        } else {
                            $(Element).find(level.submenus).show();
                            $(Element).find(' > i').removeClass('fa-chevron-right').addClass('fa-chevron-down');
                        }
                        event.stopPropagation();
                        this.checkOverflow(Element);
                    });
                    
                } else {
                    // if no submenu
                    $(Element).find('> a').before('<i class="fas fa-square"></i>');
                }
            });
            
        });
        
        // for (let [key, level] of Object.entries(this.levels)) {
        //     if (key === '0') {
        //         continue;
        //     }
            
        //     $(level.list + level.items).each((index, Element) => {
                
        //         // check if has submenu
        //         if ($(Element).find(level.submenus).length) {
                    
        //             // if has submenu add open icon
        //             $(Element).find('> a').before('<i class="fas fa-chevron-right"></i>');
                    
        //             // bind clicks to open submenus
        //             $(Element).on('click', ' > i', (event) => {
        //                 event.preventDefault();
        //                 if ($(Element).find(level.submenus).is(":visible") == true) {
        //                     $(Element).find(level.submenus).hide();
        //                     $(Element).find(' > i').removeClass('fa-chevron-down').addClass('fa-chevron-right');
        //                 } else {
        //                     $(Element).find(level.submenus).show();
        //                     $(Element).find(' > i').removeClass('fa-chevron-right').addClass('fa-chevron-down');
        //                 }
        //                 event.stopPropagation();
        //                 this.checkOverflow(Element);
        //             });
                    
        //         } else {
        //             // if no submenu
        //             $(Element).find('> a').before('<i class="fas fa-square"></i>');
        //         }
        //     });
        // }
    }
    
    checkOverflow(Element) {
        
        $(Element).closest('ul.top-menu[data-depth="0"] > li > div').css({
            'overflow-y': 'hidden',
            'overflow-x': 'hidden',
        });
        
        let listHeight = $(Element).closest('ul.top-menu[data-depth="1"]').height();
        let subMenuHeight = $(Element).closest('ul.top-menu[data-depth="0"] > li > div').height();
        
        if (listHeight > subMenuHeight - 17) {
            $(Element).closest('ul.top-menu[data-depth="0"] > li > div').css({
                'overflow-y': 'scroll',
                'overflow-x': 'hidden',
            });
        } else {
            $(Element).closest('ul.top-menu[data-depth="0"] > li > div').css({
                'overflow-y': 'hidden',
                'overflow-x': 'hidden',
            });
        }
        
    }
}



// WEBPACK FOOTER //
// ./modules/main-menu/js/main-menu.js